var React = require('react');

function ArrowLeftLarge (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","stroke":"#142B6F","strokeLinejoin":"round","strokeWidth":"6","d":"M94 27.5074L3 27.5074L94 27.5074ZM3 27.5L30.2947 3.49999L3 27.5ZM3 27.5L30.2947 51.5L3 27.5Z","clipRule":"evenodd"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"98","height":"55","fill":"#fff","transform":"translate(98 55) rotate(-180)"})))]);
}

ArrowLeftLarge.defaultProps = {"width":"78.4","height":"55","fill":"none","viewBox":"0 0 98 55"};

module.exports = ArrowLeftLarge;

ArrowLeftLarge.default = ArrowLeftLarge;
